
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BillingSCASettings',
  data() {
    return {
      chevronIconAnimateClass: ''
    }
  },
  props: {
    cancelLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Handler for the `isOpen` event emitted by `ZAccordionItem`
     *
     * @param {boolean} open
     * @returns {void}
     */
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    },
    onCancelSubscription() {
      this.$emit('cancel-subscription')
    }
  }
})
